export default "<p>get-post-id works!</p>\n"